import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { cn } from './_cn';

const PageHeader = ({
  title,
  description,
  actions,
  backTo,
  backLabel = 'Back',
  center = false,
  className = '',
}) => (
  <header
    className={cn(
      'reveal flex flex-col gap-3',
      center
        ? 'items-center text-center'
        : 'sm:flex-row sm:items-start sm:justify-between',
      className,
    )}
  >
    <div className={cn('min-w-0 space-y-1', center ? 'w-full' : 'flex-1')}>
      {backTo ? (
        <Link
          to={backTo}
          className="inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wider text-slate-500 transition hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
        >
          <ArrowLeftIcon className="h-3.5 w-3.5" aria-hidden />
          {backLabel}
        </Link>
      ) : null}
      {title ? (
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100 sm:text-3xl">
          {title}
        </h1>
      ) : null}
      {description ? (
        <p
          className={cn(
            'text-sm text-slate-500 dark:text-slate-400',
            center ? 'mx-auto max-w-2xl' : 'max-w-2xl',
          )}
        >
          {description}
        </p>
      ) : null}
    </div>
    {actions ? (
      <div className="flex flex-wrap items-center gap-2">{actions}</div>
    ) : null}
  </header>
);

export default PageHeader;
